import {ModalProps, Modal} from '../Modal/Modal';
import React, {PureComponent} from 'react';
import {DialogContainer} from './DialogContainer';
import {DialogStyleProps} from './DialogStyle';

export interface DialogProps
    extends DialogStyleProps,
        Partial<ModalProps>,
        React.HTMLAttributes<HTMLDivElement> {
    /**
     * When `true`, dialog is open.
     */
    open: boolean;
}

/**
 * Dialog component which provides a container inside a Modal component.
 */
export class DialogBase extends PureComponent<DialogProps> {
    public render() {
        const {
            open,
            transparentBackdrop,
            disableBackdropClick,
            hideBackdrop,
            onClose,
            ...props
        } = this.props;
        const modalProps = {open, transparentBackdrop, disableBackdropClick, hideBackdrop, onClose};

        return (
            <Modal {...modalProps}>
                <DialogContainer>
                    <div {...props} />
                </DialogContainer>
            </Modal>
        );
    }
}
